import trackEvent from '../../../helpers/gtm/eventPush';

const trackTime = () => {
  return new Date().toUTCString();
};

const trackSent = (messageValue) => {
  const nowTime = trackTime();
  trackEvent({
    category: 'messaging',
    action: 'contact_byemail_form_msg_sent',
    label: `ad_id=${window._sr.page.advert.id}|sender_id=${window._sr.customer.id}|recipient_id=${window._sr.page.recipient_id}|time=${nowTime}|msg=${messageValue}`,
  });
};

const addTrackingToSendButton = () => {
  const sendButton = document.querySelector(
    '#contact_form .contact-form__submit .button',
  );
  if (sendButton) {
    sendButton.addEventListener('click', (event) => {
      const messageElement = document.querySelector('#message');
      const messageValue = messageElement ? messageElement.value : '';
      if (messageValue.length != 0) {
        trackSent(messageValue);
      }
    });
  }
};

export default addTrackingToSendButton;
